import type { GetTweetById200BasicInfoAllOfTwoTweetType } from './getTweetById200BasicInfoAllOfTwoTweetType';

/**
 * 트윗 기본 정보
 */
export type GetTweetById200BasicInfoAllOfTwo = {
  content: string;
  /** 트윗 유형 */
  tweetType?: GetTweetById200BasicInfoAllOfTwoTweetType;
};
